<template>
  <RequestsReceivedWebReportPage mode="sales_manager" />
</template>

<script>
import RequestsReceivedWebReportPage from "@/components/Reports/RequestsReceivedWebReport/RequestsReceivedWebReportPage.vue";

export default {
  name: "ReceivedRequestsReport",
  components: { RequestsReceivedWebReportPage },
};
</script>
